import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author BPo
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { LoadingState } from '../../../shared/api/LoadingState';
import { StoreName } from '../../../shared/stores/StoreName';
import Loader from '../../info/Loader';
import * as moment from "moment";

var GeneralConfigurations =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GeneralConfigurations, _React$Component);

  function GeneralConfigurations() {
    _classCallCheck(this, GeneralConfigurations);

    return _possibleConstructorReturn(this, _getPrototypeOf(GeneralConfigurations).apply(this, arguments));
  }

  _createClass(GeneralConfigurations, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.store.getAll().then(function (config) {
        return moment.tz.setDefault(config.timezone);
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.store.loadingState === LoadingState.Pending) {
        return React.createElement(Loader, null);
      }

      return this.props.children;
    }
  }]);

  return GeneralConfigurations;
}(React.Component);

GeneralConfigurations = __decorate([inject(function (allStores) {
  return {
    store: allStores[StoreName.GeneralConfigurations]
  };
}), observer], GeneralConfigurations);
export default GeneralConfigurations;